module.exports = __webpack_public_path__ + "img/favorites.500b9d39.svg";